<template>
  <div class="sign-box">
    <canvas
      class="mobile"
      @touchstart="touchstart"
      @touchmove="touchmove"
      @touchend="touchend"
      v-if="mobile"
    >
    </canvas>
    <canvas
      class="pc"
      @mousedown="mousedown"
      @mousemove="mousemove"
      @mouseup="mouseup"
      @mouseout="mouseout"
      v-else
    >
    </canvas>
  </div>
</template>

<script>
export default {
  name: "signature",
  props: {
    lineWidth: {
      type: String,
      default: "5",
    },
    lineColor: {
      type: String,
      default: "#000000",
    },
    background: {
      type: String,
      default: "#ffffff",
    },
    bgOpacity: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      status: [],
      step: -1,
      first: "",
      mp: {},
    };
  },
  mounted() {
    let me = this, el = me.$el.querySelector(me.mobile ? ".mobile" : ".pc");
    me.canvas = el;
    // 动态设置元素的prop => height & width ，防止笔画变形
    el.style.width = "100%";
    el.style.height = "100%";
    el.height = el.offsetHeight;
    el.width = el.offsetWidth;

    var ctx = el.getContext("2d");
    ctx.lineWidth = me.lineWidth;
    ctx.strokeStyle = me.lineColor;
    me.ctx = ctx;
    el.style.backgroundColor = me.background;
    el.style.opacity = me.bgOpacity;
    me.first = me.getBase64PNG();
  },
  methods: {
    touchstart(e) {
      var me = this,
        x = e.touches[0].clientX - e.target.offsetLeft,
        y = e.touches[0].clientY - e.target.offsetTop;
      me.mp = {x, y};
      me.saveStatus();
    },
    touchmove(e) {
      let me = this,
        ctx = me.ctx,
        x = e.touches[0].clientX - e.target.offsetLeft,
        y = e.touches[0].clientY - e.target.offsetTop;
      ctx.beginPath();
      ctx.moveTo(me.mp.x, me.mp.y);
      me.mp = { x, y };
      ctx.lineTo(me.mp.x, me.mp.y);
      ctx.fill();
      ctx.closePath();
      ctx.stroke();
    },
    touchend() {
      this.mp = {};
    },
    mousedown(e) {
      this.mp = {};
      this.mp = {
        x: e.clientX - e.target.offsetLeft,
        y: e.clientY - e.target.offsetTop,
      };
      this.saveStatus();
    },
    mousemove(e) {
      let me = this, ctx = me.ctx;
      if (me.mp["x"] && me.mp["y"]) {
        // 如果这里不做判断，那么只要鼠标移动到画布就自动画了
        ctx.beginPath();
        ctx.moveTo(me.mp["x"], me.mp["y"]);
        me.mp = {
          x: e.clientX - e.target.offsetLeft,
          y: e.clientY - e.target.offsetTop,
        };
        ctx.lineTo(me.mp["x"], me.mp["y"]);
        ctx.fill();
        ctx.closePath();
        ctx.stroke();
      }
    },
    mouseup() {
      this.mp = {};
    },
    mouseout() {
      this.mp = {};
    },
    reset() {
      let me = this, el = me.canvas, ctx = me.ctx;
      ctx.clearRect(0, 0, el.offsetWidth, el.offsetHeight);
      let canvasPic = new Image();
      canvasPic.src = me.firstStatus;
      canvasPic.addEventListener("load", () => {
        ctx.drawImage(canvasPic, 0, 0);
      });
      me.step = -1;
      me.status = [];
    },
    getBase64PNG() {
      return this.canvas.toDataURL("image/png");
    },
    getHorizontal(callback) {
      let me = this, el = me.canvas;
      for (let i of document.querySelectorAll('canvas[data-none="1"]')) {
        i.parentNode.removeChild(i);
      }
      let hiddenEl = document.createElement("canvas");
      hiddenEl.dataset.none = "1";
      hiddenEl.width = el.offsetHeight;
      hiddenEl.height = el.offsetWidth;
      me.$el.appendChild(hiddenEl);

      let hiddenCtx = document
        .querySelector('canvas[data-none="1"]')
        .getContext("2d");
      let img = new Image();
      img.src = me.getBase64PNG();
      img.onload = function () {
        let width = Math.round(el.offsetHeight / 2);
        let height = Math.round(el.offsetWidth / 2);
        hiddenCtx.save();
        hiddenCtx.translate(width, height);
        hiddenCtx.rotate((-90 * Math.PI) / 180);
        hiddenCtx.drawImage(img, -img.width / 2, -img.height / 2);
        hiddenCtx.restore();
        callback(
          me.dataToFile(document.querySelector('canvas[data-none="1"]').toDataURL("image/png"))
        );
      };
    },
    getBlob() {
      let me = this;
      let arr = me.getBase64PNG().split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    getFile(filename) {
      let me = this;
      let dataurl = me.getBase64PNG();
      return me.dataToFile(dataurl, filename);
    },
    dataToFile(data, filename) {
      let _filename = filename || "sign.png";
      let arr = data.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], _filename, { type: mime });
    },
    draw(base64) {
      let canvasPic = new Image(), ctx = this.ctx;
      canvasPic.src = base64;
      canvasPic.addEventListener("load", () => {
        ctx.drawImage(canvasPic, 0, 0);
      });
    },
    saveStatus() {
      let me = this;
      me.step++;
      if (me.step < me.status.length) {
        me.status.length = me.step; // 截断数组
      }
      me.status.push(me.getBase64PNG());
    },
    undo(callback) {
      let me = this, el = me.canvas, ctx = me.ctx;
      if (me.step >= 0) {
        ctx.clearRect(0, 0, el.offsetWidth, el.offsetHeight);
        let canvasPic = new Image();
        canvasPic.src = me.status[me.step];
        canvasPic.addEventListener("load", () => {
          ctx.drawImage(canvasPic, 0, 0);
        });
        me.step--;
      } else {
        if (callback) callback();
      }
    },
    redo(callback) {
      let me = this, el = me.canvas, ctx = me.ctx;
      if (me.step < me.status.length - 2) {
        me.step++;
        let canvasPic = new Image();
        if (me.status[me.step + 1]) {
          canvasPic.src = me.status[me.step + 1];
          canvasPic.addEventListener("load", () => {
            ctx.clearRect(0, 0, el.offsetWidth, el.offsetHeight);
            ctx.drawImage(canvasPic, 0, 0);
          });
        }
      } else {
        if (callback) callback();
      }
    }
  },
  computed: {
    mobile() {
      var ua = navigator.userAgent.toLowerCase();
      return (
        ua.indexOf("iphone") !== -1 ||
        ua.indexOf("android") !== -1 ||
        ua.indexOf("linux") !== -1
      );
    },
  },
};
</script>

<style scoped>
* {
  touch-action: none;
}
.sign-box {
  width: 100%;
  height: 100%;
}
.mobile {
  width: 100%;
  height: 100%;
}
</style>